<script lang="ts" setup>
import '@hantecmarket/hantec-ui-widget/style.css'

import { defineAsyncComponent } from 'vue'

// Critical - above the fold, load immediately
import AdvantagesSection from '@/components/AdvantagesSection.vue'
import HeroSection from '@/components/HeroSection.vue'
import TradingBlock from '@/components/TradingBlock/TradingBlock.vue'
import {
  fetchHomepageSeoStore,
  useHomepageSeo,
  useLoadingState
} from '@/services/HomePage/seoService'
import { isSponsorshipAtleticoPresent } from '@/services/navigationService'

// Lazy loaded - below the fold
const InstrumentsWidgetSection = defineAsyncComponent(
  () => import('@/components/InstrumentsWidgetSection.vue')
)
const AccountsSection = defineAsyncComponent(() => import('@/components/AccountsSection.vue'))
const StatsReviewsBlock = defineAsyncComponent(
  () => import('@/components/StatsReviewsBlock/StatsReviewsBlock.vue')
)
const RegulationsBlock = defineAsyncComponent(
  () => import('@/components/RegulationsBlock/RegulationsBlock.vue')
)
const BalanceguardSection = defineAsyncComponent(
  () => import('@/components/BalanceguardSection.vue')
)
const PartnersBlock = defineAsyncComponent(() => import('@/components/PartnersBlock.vue'))
const InstrumentsSection = defineAsyncComponent(() => import('@/components/InstrumentsSection.vue'))
const SponsorsBlock = defineAsyncComponent(() => import('@/components/SponsorsBlock.vue'))
const YouTubeVideoSection = defineAsyncComponent(
  () => import('@/components/YouTubeVideoSection/YouTubeVideoSection.vue')
)

const loading = useLoadingState()

fetchHomepageSeoStore()
useHomepageSeo()
const isPublished = isSponsorshipAtleticoPresent()
</script>

<template>
  <main v-if="!loading">
    <HeroSection></HeroSection>
    <AdvantagesSection></AdvantagesSection>
    <TradingBlock></TradingBlock>
    <InstrumentsWidgetSection></InstrumentsWidgetSection>
    <AccountsSection></AccountsSection>
    <StatsReviewsBlock></StatsReviewsBlock>
    <RegulationsBlock></RegulationsBlock>
    <BalanceguardSection></BalanceguardSection>
    <PartnersBlock></PartnersBlock>
    <InstrumentsSection></InstrumentsSection>
    <SponsorsBlock v-if="isPublished"></SponsorsBlock>
  </main>
  <main v-if="loading">
    <div
      class="relative w-full h-full bg-black pb-2.5 md:pb-0 bg-no-repeat bg-center-26"
      style="height: 1073px"
    ></div>
  </main>
  <YouTubeVideoSection />
</template>
